import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { CodelistItemDto } from '../../dtos/codelist-item.dto';

@Injectable({ providedIn: 'root' })
export class PatientCodelistRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public getSpecies(): Observable<CodelistItemDto[]> {
    return this.http.get<CodelistItemDto[]>(`${this.apiUrl}${API_ENDPOINTS.patients.species}`);
  }

  public getBreeds(): Observable<CodelistItemDto[]> {
    return this.http.get<CodelistItemDto[]>(`${this.apiUrl}${API_ENDPOINTS.patients.breeds}`);
  }

  public getInsuranceCompanies(): Observable<CodelistItemDto[]> {
    return this.http.get<CodelistItemDto[]>(`${this.apiUrl}${API_ENDPOINTS.patients.insuranceCompanies}`);
  }
}
